import { createTypedAsyncThunk, withOrgId } from "../utils/actions";
import * as API from "@/data/api/dashboard-sections";
import { RequestParams, TDashboardSectionItem, TDashboardSectionPayload } from "@/data/types";
import { State } from "../state/state";

export const getAllDashboardSectionsAsync = createTypedAsyncThunk<
  { items: TDashboardSectionItem[] },
  RequestParams,
  { state: State }
>("dashboardSections/getAllDashboardSections", async (params, { getState }) => {
  return API.getAllDashboardSections(withOrgId(getState, params));
});

export const createDashboardSectionAsync = createTypedAsyncThunk<
  TDashboardSectionItem,
  { params?: RequestParams; payload: TDashboardSectionPayload },
  { state: State }
>("dashboardSections/createDashboardSection", async ({ params = {}, payload }, { getState }) => {
  return API.createDashboardSection(withOrgId(getState, params), payload);
});

export const getDashboardSectionByIdAsync = createTypedAsyncThunk<
  TDashboardSectionItem,
  { dashboardSectionId: string; params?: RequestParams },
  { state: State }
>("dashboardSections/getDashboardSectionById", async ({ dashboardSectionId, params = {} }, { getState }) => {
  return API.getDashboardSectionById(dashboardSectionId, withOrgId(getState, params));
});

export const updateDashboardSectionAsync = createTypedAsyncThunk<
  TDashboardSectionItem,
  { dashboardSectionId: string; params?: RequestParams; payload: Partial<TDashboardSectionPayload> },
  { state: State }
>("dashboardSections/updateDashboardSection", async ({ dashboardSectionId, params = {}, payload }, { getState }) => {
  return API.updateDashboardSection(dashboardSectionId, withOrgId(getState, params), payload);
});

export const deleteDashboardSectionAsync = createTypedAsyncThunk<
  { success: boolean },
  { dashboardSectionId: string; params?: RequestParams },
  { state: State }
>("dashboardSections/deleteDashboardSection", async ({ dashboardSectionId, params = {} }, { getState }) => {
  return API.deleteDashboardSection(dashboardSectionId, withOrgId(getState, params));
});